import { IconProps } from '@/types/icon';

export function IconeX({ size, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="x"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 26"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M4.62305 21.9331L12.0452 14.511M14.7429 11.8132L22.1694 4.38672M4.62305
      4.38672L17.49 21.9331H22.1694L9.30245 4.38672H4.62305Z"
        stroke="currentColor"
        strokeWidth="1.42268"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
